class AllGiftsHeader extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll("a");
    this.onProductAdddedListener = this.onProductAdded.bind(this);
  }

  connectedCallback() {
    document.addEventListener("product-added", this.onProductAdddedListener);
  }

  disconnectedCallback() {
    document.removeEventListener("product-added", this.onProductAdddedListener);
  }

  onProductAdded(event) {
    this.buttons.forEach(button => button.textContent = window.all_gifts.button.continue);
  }
}

if (!customElements.get("all-gifts-header")) {
  customElements.define("all-gifts-header", AllGiftsHeader)
}
